import { useEffect } from "react";
import { TRACKERS } from "@/shared/lib/consent/registry";
import { useConsent } from "@/shared/lib/consent/useConsent";
import { ConsentBanner } from "./ConsentBanner";

/**
 * Single global mount point for the consent system. Mount once near the app
 * root (next to `<ToastHost />`). It:
 *   - renders the consent banner (visible until a decision is recorded), and
 *   - runs the controller effect that loads each configured tracker once its
 *     category is granted.
 *
 * `tracker.load()` is idempotent, so re-running on every consent change (and
 * under StrictMode's double-invoke) is safe — already-loaded trackers no-op.
 */
export function ConsentRoot() {
  const { snapshot } = useConsent();

  useEffect(() => {
    if (!snapshot) return; // No decision yet — load nothing.
    for (const tracker of TRACKERS) {
      if (!tracker.isConfigured()) continue;
      const granted =
        tracker.category === "essential" || snapshot.categories[tracker.category];
      if (granted) tracker.load();
    }
  }, [snapshot]);

  return <ConsentBanner />;
}
